import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ArticleAddress } from 'models/shipments';
import { ShipmentDetailsState } from 'models/Store';

import { deleteShipments, getShipment } from '../thunks';
import { saveNickname } from '../thunks/saveNickname.thunk';

export const initialState: ShipmentDetailsState = {
  data: null,
};

export const shipmentDetailsSlice = createSlice({
  name: 'shipmentDetails',
  initialState,
  reducers: {
    updateNotificationPreference: (state, action: PayloadAction<boolean>) => {
      if (state.data?.articles?.length) {
        state.data.articles.forEach((article) => {
          article.hasNotification = action.payload;
        });
      }
    },
    updateArticleAddress: (state, action: PayloadAction<{ address: Partial<ArticleAddress>; index: number }>) => {
      const { address, index } = action.payload;
      if (!state.data || state.data.articles.length <= 0) return;
      const currentAddress = state.data.articles[index].address;
      state.data.articles[index].address = { ...currentAddress, ...address };
    },
    clearShipmentDetails: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getShipment.pending, (state) => {
      state.getShipment = { loading: true };
    });
    builder.addCase(getShipment.fulfilled, (state, action) => {
      state.data = action.payload;
      state.getShipment = null;
    });
    builder.addCase(getShipment.rejected, (state, action) => {
      state.data = null;
      state.getShipment = {
        loading: false,
        error: action.payload ?? action.error,
      };
    });
    builder.addCase(deleteShipments.pending, (state) => {
      state.deleteShipment = { loading: true };
    });
    builder.addCase(deleteShipments.fulfilled, (state) => {
      state.deleteShipment = null;
    });
    builder.addCase(deleteShipments.rejected, (state, action) => {
      state.deleteShipment = {
        loading: false,
        error: action.payload ? action.payload : action.error,
      };
    });
    builder.addCase(saveNickname.pending, (state) => {
      state.saveNickname = { loading: true, error: null };
    });
    builder.addCase(saveNickname.fulfilled, (state, action) => {
      state.saveNickname = null;
      const newNickname = action.payload;
      state.data?.articles.forEach((article) => (article.nickname = newNickname ?? null));
    });
    builder.addCase(saveNickname.rejected, (state, action) => {
      state.saveNickname = {
        loading: false,
        error: action.payload,
      };
    });
  },
});

export { deleteShipments, getShipment };
export const { updateArticleAddress, updateNotificationPreference, clearShipmentDetails } =
  shipmentDetailsSlice.actions;
